
import React from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, RefreshCw, Home, LogIn } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

export const ApplicationErrorState: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  // Log that we're rendering the error state
  console.log('Rendering ApplicationErrorState, authenticated:', isAuthenticated);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-background text-foreground">
      <div className="max-w-md text-center space-y-6 p-8 bg-card rounded-lg border shadow-lg">
        <div className="flex justify-center">
          <AlertTriangle className="h-16 w-16 text-red-500" />
        </div>
        <h1 className="text-3xl font-bold">Error Loading Application</h1>
        
        {isAuthenticated ? (
          <>
            <p className="text-lg">
              We encountered an issue while trying to load your application. This could be due to:
            </p>
            <ul className="text-left ml-6 list-disc text-muted-foreground">
              <li>A temporary database connection issue</li>
              <li>Authentication session timeout</li>
              <li>Permission issues with your account</li>
              <li>System maintenance underway</li>
            </ul>
            <div className="flex flex-col space-y-3 sm:flex-row sm:space-y-0 sm:space-x-3 justify-center">
              <Button 
                onClick={() => window.location.reload()} 
                variant="outline"
                size="lg"
                className="font-semibold"
              >
                <RefreshCw className="mr-2 h-4 w-4" />
                Try Again
              </Button>
              <Button 
                onClick={() => navigate('/')} 
                variant="default"
                size="lg"
                className="font-semibold"
              >
                <Home className="mr-2 h-4 w-4" />
                Return to Dashboard
              </Button>
            </div>
          </>
        ) : (
          <>
            <p className="text-lg">
              You need to be logged in to access the application. Please sign in to continue.
            </p>
            <div className="flex justify-center mt-4">
              <Button 
                onClick={() => navigate('/login')} 
                variant="default"
                size="lg"
                className="font-semibold"
              >
                <LogIn className="mr-2 h-4 w-4" />
                Sign In
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
